export const assessmentTemplate = [
  {
    _id: "omniHealthHistoryDemo",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2023-07-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2023-07-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniHealthHistoryDemo",
      omniTypeVersion: 1,
      title: "Health History Demo",
      purpose: "Health History Demo",
      description:
        "The information you provide will help us understand your personal health needs. We use this to match you to clinical trials.",
      duration: "Around 15 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time you experince a change in your health.",
      attribution: "",
      validated: "true",
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "ohh1",
          shortTitle: "subjectDateOfBirth",
          numberText: "1",
          text: "What is {subject name's/your} date of birth?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "date",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Date of Birth",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ohh2",
          shortTitle: "subjectZipCode",
          numberText: "2",
          text: "What is {subject name's/your} zip code?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "zipCode",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Zip Code",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: ["12345"],
          answerDate: null,
        },
        {
          omniID: "ohh3",
          shortTitle: "subjectCareGiver",
          numberText: "3",
          text: "Who is {his/her/their/your} emergency contact?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "caregiver",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: ["John Smith"],
          answerDate: null,
        },
        {
          omniID: "ohh4",
          shortTitle: "subjectEthnicity",
          numberText: "4",
          text: "{is/are} {subject name/you} of Hispanic, Latino, or of Spanish origin?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "mexicanchicano",
              text: "Mexican, Mexican Am., or Chicano",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "puertorican",
              text: "Puerto Rican",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "cuban",
              text: "Cuban",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Other",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "false",
              text: "Non-Hispanic",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: ["prefernottosay"],
          answerDate: null,
        },
        {
          omniID: "ohh5",
          shortTitle: "subjectRace",
          numberText: "5",
          text: "Which of the following options best describes {his/her/their/your} race?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "americanindianalaskanative",
              text: "American Indian/Alaska Native",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "asian",
              text: "Asian",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "blackafricanamerican",
              text: "Black or African American",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "nativehawaiianotherpacificislander",
              text: "Native Hawaiian or other Pacific Islander",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "white",
              text: "White",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "biracialmultiracial",
              text: "Biracial or Multiracial",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "prefernottosay",
              text: "Prefer not to say",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: ["prefernottosay"],
          answerDate: null,
        },
        {
          omniID: "ohh6",
          shortTitle: "subjectWeight",
          numberText: "6",
          text: "What is {subject name's/your} weight (in pounds)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "weight",
          answerOptions: [
            {
              value: "",
              text: "Weight",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ohh7",
          shortTitle: "subjectHeight",
          numberText: "7",
          text: "What is {subject name's/your} height (in feet and inches)?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "height",
          answerOptions: [
            {
              value: "",
              text: "Height",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ohh8",
          shortTitle: "subjectHealthHistory1",
          numberText: "8",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "reflux",
              text: "Acid Reflux",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "alcoholic",
              text: "Alcohol addiction",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "allergies",
              text: "Allergies",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "Anemia",
              text: "anemia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "anxiety",
              text: "Anxiety",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ohh9",
          shortTitle: "subjectHealthHistory2",
          numberText: "9",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "arteryOrVeinProblem",
              text: "Artery/Vein Problems",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "arthritis",
              text: "Arthritis",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "asthma",
              text: "Asthma",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "autoimmuneDisease",
              text: "Autoimmune Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "bipolar",
              text: "Bipolar Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["arthritis"],
          answerDate: null,
        },
        {
          omniID: "ohh10",
          shortTitle: "subjectHealthHistory3",
          numberText: "10",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "irritableBladder",
              text: "Bladder Irritability",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "bleedingProblems",
              text: "Bleeding Problems",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "bloodClots",
              text: "Blood Clots",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "cancer",
              text: "Cancer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "cataracts",
              text: "Cataracts",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["irritableBladder"],
          answerDate: null,
        },
        {
          omniID: "ohh11",
          shortTitle: "subjectHealthHistory4",
          numberText: "11",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "colitisCrohns",
              text: "Colitis / Crohns",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "chronicPain",
              text: "Chronic Pain",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "depression",
              text: "Depression",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "diabetes",
              text: "Diabetes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "drugAddiction",
              text: "Drug Addiction",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["chronicPain"],
          answerDate: null,
        },
        {
          omniID: "ohh12",
          shortTitle: "subjectHealthHistory5",
          numberText: "12",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "esophagitisUlcers",
              text: "Esophagitis, ulcers",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fractures",
              text: "Fractures",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "gallstones",
              text: "Gallstones",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "glaucoma",
              text: "Glaucoma",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "gout",
              text: "Gout",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["none"],
          answerDate: null,
        },
        {
          omniID: "ohh13",
          shortTitle: "subjectHealthHistory6",
          numberText: "13",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "headaches",
              text: "Headaches",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "hearingImpairment",
              text: "Hearing Impairment",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "heartAttack",
              text: "Heart Attack",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "heartDisease",
              text: "Heart Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "heartValveProblem",
              text: "Heart Valve Problems",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["hearingImpairment"],
          answerDate: null,
        },
        {
          omniID: "ohh14",
          shortTitle: "subjectHealthHistory7",
          numberText: "14",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "hepatitisA",
              text: "Hepatits A",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "hepatitisB",
              text: "Hepatitis B",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "hepatitisC",
              text: "Hepatitis C",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "hernia",
              text: "Hernia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "highBloodPressure",
              text: "High Blood Pressure",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["highBloodPressure"],
          answerDate: null,
        },
        {
          omniID: "ohh15",
          shortTitle: "subjectHealthHistory8",
          numberText: "15",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "highCholesterol",
              text: "High Cholesterol",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "hiv",
              text: "HIV",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "irritableBowel",
              text: "Irritable Bowel",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "kidneyDisease",
              text: "Kidney Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "kidneyStones",
              text: "Kidney Stones",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["highCholesterol"],
          answerDate: null,
        },
        {
          omniID: "ohh16",
          shortTitle: "subjectHealthHistory9",
          numberText: "16",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "liverDisease",
              text: "Liver Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "lungDisease",
              text: "Lung Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "mentalIllness",
              text: "Mental Illness",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "migraines",
              text: "Migraines",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "mrsa",
              text: "MRSA",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["none"],
          answerDate: null,
        },
        {
          omniID: "ohh17",
          shortTitle: "subjectHealthHistory10",
          numberText: "17",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "osteoporosis",
              text: "Osteoporosis",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "recurrentSkinInfection",
              text: "Recurrent Skin Infection",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "recurrentUTI",
              text: "Recurrent UTI",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "ptsd",
              text: "PTSD",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "seizures",
              text: "Seizures",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["none"],
          answerDate: null,
        },
        {
          omniID: "ohh18",
          shortTitle: "subjectHealthHistory11",
          numberText: "18",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "std",
              text: "STD",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "sleepApnea",
              text: "Sleep Apnea",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "stroke",
              text: "Stroke",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "tb",
              text: "TB",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "thyroidDisease",
              text: "Thyroid Disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: ["none"],
          answerDate: null,
        },
        {
          omniID: "ohh19",
          shortTitle: "subjectHealthHistory12",
          numberText: "19",
          text: "{has/have} {subject name/you} had any of the following conditions?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "visionImpairment",
              text: "Vision Impairment",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "other",
              text: "Something Else",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "visionImpairment",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: true,
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ohh20",
          shortTitle: "subjectAdditionalHealthHistory",
          numberText: "20",
          text: "What else should we know about your health history?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "omniMSOnboard",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
